import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '../components/pages/BusinessPage/PricingPage';

export const Route = createFileRoute('/account/business_/pricing')({
  component: PricingPage,
});
